// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gotu&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".made-by[data-v-07464a68]{bottom:0;font-family:\"Gotu\",sans-serif;font-size:small;left:0;padding:8px 0;position:absolute;text-align:center;width:100%}.made-by a[data-v-07464a68]{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
